import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success",
  "use": "success-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"success\"><g transform=\"translate(0 .5)\" fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#62B929\" cx=\"8\" cy=\"8\" r=\"8\" /><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M3.803 7.647l3.069 3.045 5.335-5.359\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id